/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';
import { enableWhyDidYouRender } from './project-config.json';

const whyDidYouRender = {
  init: async () => {
    if (process.env.NODE_ENV === 'development' && enableWhyDidYouRender) {
      // eslint-disable-next-line global-require
      const render = await import('@welldone-software/why-did-you-render');
      render(React, {
        logOnDifferentValues: false,
        include: [/^HomePage/],
      });
    }
  },
};
export { whyDidYouRender };
